export default __webpack_public_path__ + "static/media/NoRacesMascot.d75f1299.png";